import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },
  getSelfOrderDetails({ state }, orderID) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.voeSelfEmployed.getSelfOrderDetails}?orderId=${orderID}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },

  getSelfOrderReport({ state }, orderid) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.voeSelfEmployed.getSelfOrderReport}?orderid=${orderid}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  uploadVoeReportFile({ state }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.voeSelfEmployed.uploadVoeSelfApi}`,
        payload,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  getVoeSelfSecureLinkDetails({ state }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.voeSelfEmployed.getSecureLinkApi}`,
        payload,

        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  async sendVodVerification({ state }, orderID) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.voeSelfEmployed.sendMailForVerification}/${orderID}`,
        {},
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  deleteVoeSelfFiles({ state }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.voeSelfEmployed.deleteVoeSelfApi}`,
        payload,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  generateVoeSelfReport({ state }, orderId) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.voeSelfEmployed.genVoeSelfReport}?orderId=${orderId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  saveSecureLinkDetails({ state }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.voeSelfEmployed.saveSelfVoeApi}`,
        payload,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  async sendVoeSelfVerification({ state }, orderID) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.voeSelfEmployed.sendMailForVerification}/${orderID}`,
        {},

        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  submitSelfVerification({ state }, payLoad) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.voeSelfEmployed.submitSelfVerification}`,
        payLoad,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  saveProcessingDetails({ state }, payLoad) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.voeSelfEmployed.saveProcessing}`,
        payLoad,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  getAssignedTo() {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.voeSelfEmployed.getAssignedTo}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })

      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  voeSelfSendOtp({ state }, { guid }) {
    let url = `${appConfig.apiEndPoint}${endpoint.voeSelfEmployed.voeSelfSendOtp}/${guid}`
    return axios
      .post(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  voeSelfVerifyOtp({ state }, { guid, otp }) {
    let url = `${appConfig.apiEndPoint}${endpoint.voeSelfEmployed.voeSelfVerifyOtp}/${guid}/${otp}`
    return axios
      .post(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  voeSelfOtpExpiry({ state }, { guid }) {
    let url = `${appConfig.apiEndPoint}${endpoint.voeSelfEmployed.voeSelfOtpExpiry}/?guid=${guid}`
    return axios
      .get(url, { headers: setHeaders() })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
}

function setHeaders() {
  const path = window.location.href
  const url = path.includes('voe-self-securedLink')
  const urlOtp = path.includes('voeself-otpscreen')
  if (url || urlOtp) {
    return {
      'Content-Type': 'application/json',
      Authorization: '',
    }
  } else {
    return {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
    }
  }
}

function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}
